import { Directive, input } from '@angular/core';
import { OverlayTriggerBase } from './overlay-trigger-base.directive';

@Directive({
  selector: '[fcOverlayHover]',
  standalone: true,
  exportAs: 'fcOverlayHover',
  host: {
    '(mouseenter)': 'handleMouseEnter()',
    '(mouseleave)': 'handleMouseLeave()',
  },
})
export class OverlayHoverDirective extends OverlayTriggerBase {
  closeDelay = input<number>(140);

  protected override openMode = 'hover' as const;

  private closeTimer?: ReturnType<typeof setTimeout>;

  protected override setupOverlayListeners(): void {
    if (this.overlayElement) {
      this.overlayElement.addEventListener(
        'mouseenter',
        this.handleOverlayMouseEnter,
      );
      this.overlayElement.addEventListener(
        'mouseleave',
        this.handleOverlayMouseLeave,
      );
    }
  }

  protected override cleanupOverlayListeners(): void {
    this.cancelClose();

    if (this.overlayElement) {
      this.overlayElement.removeEventListener(
        'mouseenter',
        this.handleOverlayMouseEnter,
      );
      this.overlayElement.removeEventListener(
        'mouseleave',
        this.handleOverlayMouseLeave,
      );
    }
  }

  protected handleMouseEnter(): void {
    this.cancelClose();
    this.showOverlay();
  }

  protected handleMouseLeave(): void {
    this.closeDelayed();
  }

  private handleOverlayMouseEnter = (): void => {
    this.cancelClose();
  };

  private handleOverlayMouseLeave = (): void => {
    this.closeDelayed();
  };

  private closeDelayed(): void {
    this.cancelClose();
    this.closeTimer = setTimeout(() => {
      this.hideOverlay();
    }, this.closeDelay());
  }

  private cancelClose(): void {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = undefined;
    }
  }
}
